<div class="grid">
  <div class="grid__col-sm-10 grid__col-xs-12 center-item center-text">
    <h2 class="h2" tabindex="-1" dgxAutofocus>
      {{ onboardingRoleTitle }}
    </h2>
    <p class="par guts-p-t-1">
      {{ onboardingRoleDescription }}
    </p>
  </div>
  <div class="grid__col-12 grid__col--bleed __search-roles">
    <div class="grid__col-sm-4 center-item center-text">
      <dgx-role-search></dgx-role-search>
    </div>

    <df-spinner *ngIf="!(featuredRoles | async)"></df-spinner>
    <dgx-role-select-items
      *ngIf="featuredRoles | async as roles"
      [featuredRoles]="featuredRoles"
      [jobRoleIntegrationProvider]="jobRoleIntegrationProvider"
    ></dgx-role-select-items>
  </div>
</div>
